<div class="pv2-adicional-editor"
     [class.is-creation-config]="creationPhase === 'config'"
     [class.is-full-phase]="creationPhase === 'full'"
     [class.is-choice-mode]="isChoiceMode"
     [class.is-library-mode]="isLibraryMode"
     [class.is-create-mode]="isCreateMode"
     [class.is-embedded-context]="isEmbeddedContext"
     *ngIf="groupDraft">
  <div class="pv2-adicional-editor__content">

  <header class="pv2-adicional-hero" *ngIf="!isChoiceMode">
    <button type="button" class="pv2-adicional-hero__back" (click)="goBack()">
      <span class="fa fa-chevron-left"></span>
    </button>
    <div>
      <h2>{{ mode === 'create' ? 'Criar adicional' : (groupDraft?.name || 'Editar adicional') }}</h2>
      <span class="pv2-adicional-hero__status">
        <span class="pv2-adicional-hero__dot"></span>
        {{ heroStatusLabel }}
      </span>
    </div>
  </header>

  <div class="pv2-adicional-header__lead" *ngIf="isChoiceMode">
    <h3>Como deseja adicionar?</h3>
    <p>Escolha como criar seu novo adicional.</p>
  </div>

  <section class="pv2-choice-shell" *ngIf="isChoiceMode">
    <div class="pv2-choice-grid">
      <article class="pv2-choice-card"
               [class.is-selected]="choiceSelection === 'create'"
               (click)="selectChoice('create')">
        <div class="pv2-choice-card__icon is-create">
          <span class="fa fa-plus"></span>
        </div>
        <h4>Criar do zero</h4>
        <p>Defina nome, tipo de seleção e cobrança do zero. Ideal para adicionais únicos deste produto.</p>
        <div class="pv2-choice-card__footer">
          <span class="pv2-choice-card__radio" [class.is-selected]="choiceSelection === 'create'">
            <span class="fa fa-circle"></span>
          </span>
          <span>{{ choiceSelection === 'create' ? 'Selecionado' : 'Selecionar' }}</span>
        </div>
      </article>

      <article class="pv2-choice-card"
               [class.is-selected]="choiceSelection === 'library'"
               (click)="selectChoice('library')">
        <div class="pv2-choice-card__icon is-library">
          <span class="fa fa-book"></span>
        </div>
        <h4>Da biblioteca</h4>
        <p>Reaproveite um adicional já criado em outro produto. Vincule ou duplique com um clique.</p>
        <div class="pv2-choice-card__footer">
          <span class="pv2-choice-card__radio" [class.is-selected]="choiceSelection === 'library'">
            <span class="fa fa-circle"></span>
          </span>
          <span>{{ choiceSelection === 'library' ? 'Selecionado' : 'Selecionar' }}</span>
        </div>
      </article>
    </div>

    <div class="pv2-wizard-actions">
      <button type="button" class="pv2-ghost-btn" (click)="goBack()">Cancelar</button>
      <button type="button" class="pv2-primary-btn pv2-wizard-actions__primary"
              [disabled]="!canContinueChoice"
              (click)="onContinue()">
        Continuar
        <span class="fa fa-arrow-right"></span>
      </button>
    </div>
  </section>

  <section class="pv2-wizard-shell" *ngIf="isCreateMode">
    <div class="pv2-wizard-grid" *ngIf="!isMobile; else mobileCreateWizardTpl">
      <div class="pv2-wizard-grid__main-column">
        <div class="pv2-shared-banner" *ngIf="hasSharedUsageInOtherProducts">
          <span class="fa fa-link"></span>
          <div class="pv2-shared-banner__content">
            <strong>Adicional compartilhado</strong>
            <span>Esta alteração irá afetar também nos outros produtos.</span>
            <div class="pv2-shared-banner__products" *ngIf="sharedProductNames.length">
              <span class="pv2-shared-banner__chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
              <span class="pv2-shared-banner__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="identityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="optionsCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="wizardActionsTpl"></ng-container>
      </div>

      <div class="pv2-wizard-grid__side-column">
        <ng-container *ngTemplateOutlet="rulesCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="summaryCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="previewPanelTpl"></ng-container>
      </div>
    </div>

    <ng-template #mobileCreateWizardTpl>
      <div class="pv2-wizard-grid pv2-wizard-grid--stacked">
        <div class="pv2-shared-banner" *ngIf="hasSharedUsageInOtherProducts">
          <span class="fa fa-link"></span>
          <div class="pv2-shared-banner__content">
            <strong>Adicional compartilhado</strong>
            <span>Esta alteração irá afetar também nos outros produtos.</span>
            <div class="pv2-shared-banner__products" *ngIf="sharedProductNames.length">
              <span class="pv2-shared-banner__chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
              <span class="pv2-shared-banner__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="identityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="rulesCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="optionsCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="summaryCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="wizardActionsTpl"></ng-container>
        <ng-container *ngTemplateOutlet="previewPanelTpl"></ng-container>
      </div>
    </ng-template>

    <ng-template #identityCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('identity')">
          <div class="pv2-section-card__icon is-identity">
            <span class="fa fa-pencil-alt"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Identidade</h4>
            <p>Nome e tipo de seleção</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('identity') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('identity')">
          <label class="pv2-form-field">
            <span>Nome do adicional <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o nome irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <input [(ngModel)]="groupDraft.name"
                   (ngModelChange)="onFieldChange()"
                   type="text"
                   placeholder="Ex: Escolha sua calda"
                   [disabled]="!podeEditar">
          </label>

          <div class="pv2-form-section">
            <span class="pv2-form-section__label">Tipo de seleção <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o tipo de seleção irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <div class="pv2-pill-grid">
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'single'"
                      (click)="groupDraft.type = 'single'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-dot-circle-o"></span> Única
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multiple'"
                      (click)="groupDraft.type = 'multiple'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-check-square"></span> Múltipla
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multipleRepeat'"
                      (click)="groupDraft.type = 'multipleRepeat'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-clone"></span> Múltipla c/ rep.
              </button>
            </div>
          </div>
        </div>
      </article>
    </ng-template>

    <ng-template #rulesCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('rules')">
          <div class="pv2-section-card__icon is-rules">
            <span class="fa fa-shield-alt"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Regras</h4>
            <p>Obrigatoriedade, limites e cobrança</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('rules') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('rules')">
          <label class="pv2-toggle-row pv2-toggle-box">
            <div class="pv2-toggle-box__label">
              <span class="fa fa-info-circle"></span>
              <span>Obrigatório <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Ativar ou desativar a obrigatoriedade irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            </div>
            <div class="pv2-toggle-switch">
              <input type="checkbox" [(ngModel)]="groupDraft.required" (ngModelChange)="onFieldChange()"
                     [disabled]="!podeEditar">
              <span class="pv2-toggle-switch__track"></span>
            </div>
          </label>

          <div class="pv2-form-grid">
            <label class="pv2-form-field">
              <span>Mínimo <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o mínimo irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span></span></span>
              <input [(ngModel)]="groupDraft.min" (ngModelChange)="onFieldChange()" type="number" min="0"
                     [disabled]="!podeEditar">
            </label>
            <label class="pv2-form-field">
              <span>Máximo <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o máximo irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span></span></span>
              <input [(ngModel)]="groupDraft.max" (ngModelChange)="onFieldChange()" type="number" min="1"
                     [disabled]="!podeEditar">
            </label>
          </div>

          <div class="pv2-form-section">
            <span class="pv2-form-section__label">Tipo de cobrança <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o tipo de cobrança irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <div class="pv2-pill-grid">
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'soma'"
                      (click)="groupDraft.chargeType = 'soma'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-plus-circle"></span> Soma
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'media'"
                      (click)="groupDraft.chargeType = 'media'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-balance-scale"></span> Média
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'maior'"
                      (click)="groupDraft.chargeType = 'maior'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-arrow-up"></span> Maior
              </button>
            </div>
          </div>
        </div>
      </article>
    </ng-template>

    <ng-template #optionsCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('options')">
          <div class="pv2-section-card__icon is-options">
            <span class="fa fa-th-large"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Opções</h4>
            <p>Itens que o cliente poderá escolher</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('options') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('options')">
          <section class="pv2-add-option-section">
            <div class="pv2-add-option-section__header">
              <span class="pv2-add-option-section__label">Adicionar opções <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Adicionar ou remover opções irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
              <span class="pv2-add-option-section__hint">Pressione Enter para adicionar</span>
            </div>
            <div class="pv2-add-option-row">
              <input type="text" class="pv2-add-option-row__name"
                     [(ngModel)]="newOptionName"
                     placeholder="Nome da opção (Ex: Calda de morango)"
                     (keydown.enter)="addOptionFromInput()">
              <div class="pv2-add-option-row__price-wrap">
                <span class="pv2-add-option-row__prefix">R$</span>
                <input type="text" class="pv2-add-option-row__price"
                       [(ngModel)]="newOptionPrice"
                       placeholder="0,00"
                       inputmode="decimal"
                       (keydown.enter)="addOptionFromInput()">
              </div>
              <button type="button" class="pv2-add-option-row__btn"
                      [disabled]="!newOptionName.trim()"
                      (click)="addOptionFromInput()">
                <span class="fa fa-plus"></span>
              </button>
            </div>
          </section>

          <ng-container *ngIf="hasOptions; else emptyOptionsTpl">
            <div class="pv2-group-mode-switch" [ngClass]="modeThemeClass">
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isReviewMode"
                      [ngClass]="{'is-editar': isReviewMode}"
                      (click)="setOptionMode('review')">
                <span class="fa fa-pencil"></span>
                Editar
              </button>
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isActivationMode"
                      [ngClass]="{'is-onoff': isActivationMode}"
                      (click)="setOptionMode('activation')">
                <span class="fa fa-toggle-on"></span>
                Ativar/Desativar
              </button>
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isBatchPriceMode"
                      [ngClass]="{'is-lote': isBatchPriceMode}"
                      (click)="setOptionMode('batch-price')">
                <span class="fa fa-th"></span>
                Preço em massa
              </button>
            </div>

            <div class="pv2-gd-banner" [ngClass]="modeThemeClass">
              <span class="pv2-gd-banner__icon">
                <span class="fa" [ngClass]="{
                  'fa-check-circle': isActivationMode,
                  'fa-pencil': isReviewMode,
                  'fa-check-square': isBatchPriceMode
                }"></span>
              </span>
              <span *ngIf="isActivationMode">Toque para ativar ou desativar opções.</span>
              <span *ngIf="isReviewMode">Toque em uma opção para editar nome, preço e detalhes.</span>
              <span *ngIf="isBatchPriceMode">Selecione várias opções para aplicar ações em massa.</span>
            </div>

            <section class="pv2-group-detail-options-shell" *ngIf="showSearchAndSort">
              <div class="pv2-gd-toolbar">
                <label class="pv2-search pv2-gd-search">
                  <span class="fa fa-search"></span>
                  <input [ngModel]="optionSearch" (ngModelChange)="setOptionSearch($event)"
                         type="text" placeholder="Pesquisar opções...">
                </label>
                <div class="pv2-gd-sort-row">
                  <div class="pv2-gd-sort">
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'name-asc'"
                            (click)="setOptionSort('name-asc')">A-Z</button>
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-asc'"
                            (click)="setOptionSort('price-asc')">R$ &#8593;</button>
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-desc'"
                            (click)="setOptionSort('price-desc')">R$ &#8595;</button>
                  </div>
                  <span class="pv2-gd-item-count">{{ filteredOptions.length }} itens</span>
                </div>
              </div>
            </section>

            <div class="pv2-gd-batch-bar" *ngIf="isBatchPriceMode">
              <div class="pv2-gd-batch-bar__counter">
                <strong>{{ batchSelectedCount }}/{{ filteredOptions.length }}</strong>
                <button type="button" class="pv2-chip" (click)="selectAllFilteredBatchOptions()">Todos</button>
                <button type="button" class="pv2-chip" (click)="clearBatchSelection()">Nenhum</button>
              </div>
              <div class="pv2-gd-batch-bar__actions">
                <button type="button" class="pv2-primary-btn pv2-gd-batch-bar__price-btn"
                        (click)="openBatchSheet()">
                  Alterar preço
                </button>
                <button type="button" class="pv2-gd-batch-bar__on-btn"
                        (click)="applyBatchAvailability(true)">
                  <span class="fa fa-check"></span> Ativar
                </button>
                <button type="button" class="pv2-gd-batch-bar__off-btn"
                        (click)="applyBatchAvailability(false)">
                  <span class="fa fa-ban"></span> Desativar
                </button>
              </div>
            </div>

            <div class="pv2-gd-chip-flow" [ngClass]="modeThemeClass"
                 *ngIf="filteredOptions.length; else emptyFilterTpl">
              <ng-container *ngIf="isActivationMode">
                <button type="button" class="pv2-option-chip is-mode-onoff"
                        *ngFor="let option of filteredOptions; trackBy: trackByOption"
                        [class.is-active]="option.active !== false"
                        [class.is-inactive]="option.active === false"
                        (click)="onChipClickOnOff(option)">
                  <span class="pv2-option-chip__status-dot" [class.is-on]="option.active !== false">
                    <span class="fa fa-check" *ngIf="option.active !== false"></span>
                  </span>
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="isReviewMode">
                <button type="button" class="pv2-option-chip is-mode-editar"
                        *ngFor="let option of filteredOptions; trackBy: trackByOption"
                        [class.is-active]="option.active !== false"
                        [class.is-inactive]="option.active === false"
                        [class.is-editing]="isEditingOption(option)"
                        (click)="onChipClickEditar(option)">
                  <span class="pv2-option-chip__edit-dot">
                    <span class="fa fa-pencil-alt"></span>
                  </span>
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="isBatchPriceMode">
                <button type="button" class="pv2-option-chip is-mode-lote"
                        *ngFor="let option of filteredOptions; trackBy: trackByOption"
                        [class.is-selected]="isBatchOptionSelected(option)"
                        (click)="onChipClickLote(option)">
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.0-0':'pt' }}</span>
                </button>
              </ng-container>
            </div>
          </ng-container>

          <ng-template #emptyOptionsTpl>
            <section class="pv2-adicional-empty">
              <div class="pv2-adicional-empty__icon">📋</div>
              <h3>Nenhuma opção adicionada</h3>
              <p>Adicione pelo menos 1 opção para salvar o adicional.</p>
            </section>
          </ng-template>

          <ng-template #emptyFilterTpl>
            <div class="pv2-empty pv2-empty--inline pv2-empty--compact" *ngIf="showSearchAndSort">
              <h3>Nenhuma opção encontrada</h3>
              <p>Ajuste a busca para voltar a exibir as opções deste adicional.</p>
            </div>
          </ng-template>
        </div>
      </article>
    </ng-template>

    <ng-template #summaryCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('summary')">
          <div class="pv2-section-card__icon is-summary">
            <span class="fa fa-clipboard-list"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Resumo e ações</h4>
            <p>Revise o escopo do adicional</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('summary') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('summary')">
          <div class="pv2-wizard-summary">
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Escopo</span>
              <strong>{{ groupDraft.shared ? ('Compartilhado em ' + groupDraft.sharedCount + ' produtos') : 'Só neste produto' }}</strong>
              <div class="pv2-wizard-summary__products" *ngIf="sharedProductNames.length">
                <span class="pv2-wizard-summary__product-chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
                <span class="pv2-wizard-summary__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
              </div>
            </div>
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Seleção</span>
              <strong>{{ groupDraft.type === 'single' ? 'Única' : groupDraft.type === 'multipleRepeat' ? 'Múltipla c/ repetição' : 'Múltipla' }}</strong>
            </div>
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Opções</span>
              <strong>{{ groupDraft.options.length }} cadastradas</strong>
            </div>
          </div>

          <button type="button" class="pv2-remove-group-btn"
                  *ngIf="mode === 'edit'"
                  (click)="requestDelete()"
                  [disabled]="!podeEditar">
            <span class="fa fa-trash"></span>
            {{ groupDraft.shared ? 'Remover deste produto' : 'Excluir adicional' }}
          </button>
        </div>
      </article>
    </ng-template>

    <ng-template #wizardActionsTpl>
      <div class="pv2-wizard-actions pv2-wizard-actions--condensed is-end">
        <button type="button" class="pv2-ghost-btn" (click)="goBack()">
          <span class="fa fa-arrow-left"></span>
          Voltar
        </button>
        <button type="button" class="pv2-ghost-btn"
                [disabled]="!canContinue || !hasOptions"
                (click)="onSave()">
          Salvar
        </button>
        <button type="button" class="pv2-primary-btn pv2-wizard-actions__primary"
                [disabled]="!canContinue || !hasOptions"
                (click)="onSaveAndClose()">
          Salvar e Fechar
          <span class="fa fa-check"></span>
        </button>
      </div>
    </ng-template>

    <ng-template #previewPanelTpl>
      <aside class="pv2-preview-panel">
        <span class="pv2-preview-panel__eyebrow">Preview</span>
        <article class="pv2-preview-card-inline">
          <h4>{{ previewTitle }}</h4>
          <span class="pv2-preview-card-inline__badge" *ngIf="previewRequired">Obrigatório</span>
          <p class="pv2-preview-card-inline__meta">{{ previewSelectionText }}</p>

          <div class="pv2-preview-card-inline__options" *ngIf="previewOptions.length; else previewEmptyTpl">
            <label class="pv2-preview-card-inline__option" *ngFor="let option of previewOptions">
              <input [type]="groupDraft.type === 'single' ? 'radio' : 'checkbox'">
              <span>{{ option }}</span>
            </label>
          </div>
          <ng-template #previewEmptyTpl>
            <div class="pv2-preview-card-inline__empty">As opções aparecerão aqui conforme você configurar o adicional.</div>
          </ng-template>

          <footer class="pv2-preview-card-inline__footer">
            <span class="fa fa-eye"></span>
            Visão do cliente
          </footer>
        </article>

        <article class="pv2-preview-tip-card">
          <div class="pv2-preview-tip-card__title">
            <span class="fa" [ngClass]="isLibraryMode ? 'fa-info-circle' : (groupDraft.shared ? 'fa-link' : 'fa-eye')"></span>
            {{ previewHintTitle }}
          </div>
          <p>{{ previewHintText }}</p>
        </article>
      </aside>
    </ng-template>
  </section>

  <section class="pv2-wizard-shell" *ngIf="isLibraryMode">
    <div class="pv2-wizard-grid">
      <article class="pv2-wizard-main-card pv2-library-main-card">
        <header class="pv2-library-header">
          <button type="button" class="pv2-library-header__back" (click)="goToPreviousStep()">
            <span class="fa fa-chevron-left"></span>
          </button>
          <div>
            <h3>Vincular Adicional</h3>
            <p>Grupo de complementos</p>
          </div>
        </header>

        <div class="pv2-library-product-bar">
          <span><strong class="pv2-library-product-bar__label">PRODUTO:</strong> {{ editor?.name }}</span>
          <button type="button" class="pv2-library-product-bar__link" (click)="goBack()">Alterar</button>
        </div>

        <label class="pv2-search pv2-library-search">
          <span class="fa fa-search"></span>
          <input [ngModel]="librarySearch"
                 (ngModelChange)="onLibrarySearchChange($event)"
                 type="text"
                 placeholder="Buscar por adicional ou produto...">
        </label>

        <div class="pv2-chip-row">
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Todos'" (click)="setLibraryFilter('Todos')">Todos</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Compartilhados'" (click)="setLibraryFilter('Compartilhados')">Compartilhados</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Exclusivos'" (click)="setLibraryFilter('Exclusivos')">Exclusivos</button>
        </div>

        <p class="pv2-library-hint-text">
          <span class="fa fa-info-circle"></span>
          Selecione para vincular ou duplicar grupos ao produto
        </p>

        <div class="pv2-library-list" *ngIf="!libraryLoading; else libraryLoadingTpl">

          <div class="pv2-library-product-group"
               *ngFor="let group of filteredLibraryProductGroups"
               [class.is-shared-group]="group.productId === -1"
               [class.is-expanded]="group.expanded">

            <button type="button" class="pv2-library-product-group__header"
                    (click)="toggleProductGroup(group.productId)">
              <div class="pv2-library-product-group__icon"
                   [class.is-shared]="group.productId === -1">
                <span class="fa" [ngClass]="group.productId === -1
                  ? 'fa-share-alt'
                  : getProductTypeIcon(group.productType)"></span>
              </div>
              <div class="pv2-library-product-group__info">
                <h4>{{ group.productName }}</h4>
                <span class="pv2-library-product-group__count">
                  {{ group.adicionais.length }} adiciona{{ group.adicionais.length === 1 ? 'l' : 'is' }}
                </span>
              </div>
              <span class="fa pv2-library-product-group__chevron"
                    [ngClass]="group.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </button>

            <div class="pv2-library-product-group__body" *ngIf="group.expanded">
              <article class="pv2-library-compact-card"
                       *ngFor="let item of group.adicionais"
                       [class.is-selected]="isLibraryGroupSelected(item)"
                       (click)="selectLibraryGroup(item)">
                <div class="pv2-library-compact-card__main">
                  <div class="pv2-library-compact-card__name-row">
                    <h5>{{ item.name }}</h5>
                    <span class="pv2-library-compact-card__shared-badge" *ngIf="item.sharedCount > 1">
                      <span class="fa fa-share-alt"></span> {{ item.sharedCount }} produtos
                    </span>
                    <span class="pv2-library-compact-card__linked-badge" *ngIf="isLibraryGroupLinked(item)">
                      <span class="fa fa-check"></span> Vinculado
                    </span>
                  </div>
                  <span class="pv2-library-compact-card__preview" *ngIf="item.previewOptions?.length">
                    {{ item.previewOptions.join(', ') }}
                  </span>
                  <span class="pv2-library-compact-card__rules">
                    {{ item.description }}
                  </span>
                  <div class="pv2-library-compact-card__products"
                       *ngIf="group.productId === -1 && item.sharedProductNames?.length">
                    <span class="pv2-library-compact-card__product-chip"
                          *ngFor="let pName of item.sharedProductNames.slice(0, 4)">{{ pName }}</span>
                    <span class="pv2-library-compact-card__products-more"
                          *ngIf="item.sharedProductNames.length > 4">
                      +{{ item.sharedProductNames.length - 4 }} mais
                    </span>
                  </div>
                </div>
                <div class="pv2-library-compact-card__actions">
                  <button type="button" class="pv2-compact-btn is-primary"
                          (click)="useLibraryGroup(item, false); $event.stopPropagation()">
                    <span class="fa fa-link"></span> Vincular
                  </button>
                  <button type="button" class="pv2-compact-btn is-muted"
                          (click)="useLibraryGroup(item, true); $event.stopPropagation()">
                    <span class="fa fa-clone"></span> Duplicar
                  </button>
                </div>
              </article>
            </div>
          </div>

          <div class="pv2-empty pv2-empty--inline" *ngIf="!totalFilteredAdicionais">
            <h3>Nenhum adicional encontrado</h3>
            <p>Ajuste a busca para encontrar um adicional existente no catálogo.</p>
          </div>
        </div>

        <ng-template #libraryLoadingTpl>
          <div class="pv2-library-product-group" *ngFor="let skeleton of [1,2,3]">
            <div class="pv2-library-product-group__header" style="pointer-events: none;">
              <div class="pv2-library-product-group__icon">
                <div class="pv2-skel pv2-skel-circle"></div>
              </div>
              <div class="pv2-library-product-group__info">
                <div class="pv2-skel pv2-skel-line"></div>
                <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
              </div>
            </div>
          </div>
        </ng-template>
      </article>

      <aside class="pv2-preview-panel" *ngIf="!isMobile">
        <span class="pv2-preview-panel__eyebrow">Preview</span>
        <article class="pv2-preview-card-inline">
          <h4>{{ previewTitle }}</h4>
          <span class="pv2-preview-card-inline__badge" *ngIf="previewRequired">Obrigatório</span>
          <p class="pv2-preview-card-inline__meta">{{ previewSelectionText }}</p>

          <div class="pv2-preview-card-inline__options" *ngIf="previewOptions.length; else libraryPreviewEmptyTpl">
            <label class="pv2-preview-card-inline__option" *ngFor="let option of previewOptions">
              <input [type]="selectedLibraryGroup?.type === 'single' ? 'radio' : 'checkbox'">
              <span>{{ option }}</span>
            </label>
          </div>
          <ng-template #libraryPreviewEmptyTpl>
            <div class="pv2-preview-card-inline__empty">Selecione um item da biblioteca para visualizar as opções.</div>
          </ng-template>

          <footer class="pv2-preview-card-inline__footer">
            <span class="fa fa-eye"></span>
            Visão do cliente
          </footer>
        </article>

        <article class="pv2-preview-tip-card">
          <div class="pv2-preview-tip-card__title">
            <span class="fa fa-info-circle"></span>
            {{ previewHintTitle }}
          </div>
          <p>{{ previewHintText }}</p>
        </article>
      </aside>
    </div>
  </section>

  <kendo-dialog [title]="deleteDialogTitle" *ngIf="showDeleteDialog" [minWidth]="320" [width]="420" (close)="cancelDelete()">
    <p>{{ deleteDialogBody }}</p>
    <kendo-dialog-actions>
      <button type="button" class="pv2-ghost-btn" (click)="cancelDelete()">Cancelar</button>
      <button type="button" class="pv2-primary-btn pv2-danger-btn" (click)="confirmDelete()">{{ deleteActionLabel }}</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <div class="pv2-adicional-editor__overlay-host">
    <div class="pv2-overlay pv2-overlay--sheet" *ngIf="editSheetOpen" (click)="closeEditSheet()"></div>
    <section class="pv2-edit-sheet" *ngIf="editSheetOpen">
      <div class="pv2-edit-sheet__handle"></div>
      <header class="pv2-edit-sheet__header">
        <h3>Editar opção</h3>
        <button type="button" class="pv2-icon-btn" (click)="closeEditSheet()">
          <span class="fa fa-times"></span>
        </button>
      </header>
      <div class="pv2-edit-sheet__body">
        <label class="pv2-edit-sheet__field">
          <span>Nome</span>
          <input [(ngModel)]="editingOptionName" placeholder="Nome da opção"
                 (keydown.enter)="saveAndCloseEditSheet()" (keydown.escape)="closeEditSheet()">
        </label>
        <div class="pv2-edit-sheet__row">
          <label class="pv2-edit-sheet__field pv2-edit-sheet__field--kendo">
            <span>Preço (R$)</span>
            <kendo-numerictextbox [(ngModel)]="editingOptionPrice"
                                  [min]="0" [spinners]="false" [format]="'n2'"
                                  placeholder="0,00">
            </kendo-numerictextbox>
          </label>
          <label class="pv2-edit-sheet__field">
            <span>Código PDV</span>
            <input [(ngModel)]="editingOptionPdv" placeholder="Código PDV"
                   (keydown.enter)="saveAndCloseEditSheet()" (keydown.escape)="closeEditSheet()">
          </label>
        </div>

        <button type="button" class="pv2-edit-sheet__advanced-toggle"
                [class.is-open]="editSheetAdvancedOpen"
                (click)="editSheetAdvancedOpen = !editSheetAdvancedOpen">
          <span class="fa fa-sliders"></span>
          Opções avançadas
          <span class="pv2-edit-sheet__advanced-badge"
                *ngIf="!editSheetAdvancedOpen && hasAdvancedOptionData()">
            <span class="fa fa-circle"></span>
          </span>
          <span class="fa fa-chevron-down pv2-edit-sheet__advanced-chevron"></span>
        </button>

        <div class="pv2-edit-sheet__advanced-body" *ngIf="editSheetAdvancedOpen">
          <div class="pv2-edit-sheet__field pv2-edit-sheet__field--image">
            <span>Imagem</span>
            <div class="pv2-option-image-upload">
              <div class="pv2-option-image-upload__preview" *ngIf="editingOptionLinkImagem">
                <img [src]="resolveOptionImageUrl(editingOptionLinkImagem)" alt="Imagem da opção">
                <button type="button" class="pv2-option-image-upload__remove" (click)="removeOptionImage()">
                  <span class="fa fa-times"></span>
                </button>
              </div>
              <label class="pv2-option-image-upload__btn" *ngIf="!editingOptionLinkImagem && !editingOptionUploadingImage">
                <span class="fa fa-camera"></span>
                <span>Adicionar imagem</span>
                <input type="file" accept="image/*" (change)="onOptionImageSelected($event)" hidden>
              </label>
              <div class="pv2-option-image-upload__loading" *ngIf="editingOptionUploadingImage">
                <span class="fa fa-spinner fa-spin"></span> Enviando...
              </div>
            </div>
          </div>

          <label class="pv2-edit-sheet__field">
            <span>Descrição</span>
            <textarea [(ngModel)]="editingOptionDescription" placeholder="Descrição da opção (opcional)"
                      rows="2" (keydown.escape)="closeEditSheet()"></textarea>
          </label>

          <label class="pv2-edit-sheet__field pv2-edit-sheet__field--kendo">
            <span>Qtde. máxima por opção</span>
            <kendo-numerictextbox [(ngModel)]="editingOptionQtdeMaxima"
                                  [min]="0" [spinners]="false" [format]="'n0'"
                                  placeholder="Sem limite">
            </kendo-numerictextbox>
          </label>
        </div>
      </div>
      <footer class="pv2-edit-sheet__footer">
        <div class="pv2-edit-sheet__btn-row">
          <button type="button" class="pv2-ghost-btn" (click)="closeEditSheet()">Cancelar</button>
          <button type="button" class="pv2-primary-btn" (click)="saveAndCloseEditSheet()">Salvar</button>
        </div>
        <button type="button" class="pv2-edit-sheet__delete" (click)="deleteAndCloseEditSheet()">
          <span class="fa fa-trash"></span> Excluir opção
        </button>
      </footer>
    </section>

    <div class="pv2-overlay pv2-overlay--sheet" *ngIf="batchSheetOpen" (click)="closeBatchSheet()"></div>
    <section class="pv2-batch-sheet" *ngIf="batchSheetOpen">
      <div class="pv2-batch-sheet__handle"></div>
      <header class="pv2-batch-sheet__header">
        <div>
          <h3>Alterar preço</h3>
          <span>{{ batchSelectedCount }} selecionados</span>
        </div>
        <button type="button" class="pv2-icon-btn" (click)="closeBatchSheet()">
          <span class="fa fa-times"></span>
        </button>
      </header>
      <div class="pv2-batch-sheet__tabs">
        <button type="button" class="pv2-batch-sheet__tab"
                [class.is-active]="batchAdjustMode === 'fixed'"
                (click)="setBatchAdjustMode('fixed')">Fixo</button>
        <button type="button" class="pv2-batch-sheet__tab"
                [class.is-active]="batchAdjustMode === 'increment'"
                (click)="setBatchAdjustMode('increment')">+/-</button>
        <button type="button" class="pv2-batch-sheet__tab"
                [class.is-active]="batchAdjustMode === 'percent'"
                (click)="setBatchAdjustMode('percent')">%</button>
      </div>
      <div class="pv2-batch-sheet__body">
        <label class="pv2-batch-sheet__field">
          <span *ngIf="batchAdjustMode === 'fixed'">R$</span>
          <span *ngIf="batchAdjustMode === 'increment'">+/-</span>
          <span *ngIf="batchAdjustMode === 'percent'">%</span>
          <input [(ngModel)]="batchAdjustValue" type="text" inputmode="decimal" placeholder="0">
        </label>
      </div>
      <footer class="pv2-batch-sheet__footer">
        <button type="button" class="pv2-primary-btn pv2-full-btn pv2-batch-sheet__apply"
                (click)="applyBatchAdjust()">
          Aplicar
        </button>
      </footer>
    </section>
  </div>
</div>
